import reduxStore from "../../../../../src/redux/store";
export const getFontSizeByMedium = (mediumName) => {
  if (!mediumName) return 12;
  if (mediumName === "hindi") return 11;
  if (mediumName === "english") return 12;

  return 12;
};

export const commonLabels = {
  en: {
    termsAndConditions: "General Instructions",
    enterNoOfQuestions: "Enter No of Questions",
    marksPerQuestion: "Marks Per Question",
    addYourOwnQuestion: "Add your own question",
    selectChapter: "Select Chapter",
    questions: "Questions",
    class: "Class",
    subject: "Subject",
    time: "Time",
    maxMarks: "Max Marks",
    noQuestionsFound: "No Questions Available",
    header: "Header",
    displayHeader: "Display Header",
    normalHeader: "Normal Header",
    letterHead: "Letter Head",
    onlyLogo: "Logo Only",
    height: "Height",
    width: "Width",
    goBack: "Go Back",
  },
  hi: {
    termsAndConditions: "सामान्य निर्देश",
    enterNoOfQuestions: "प्रश्नों की संख्या डालें",
    marksPerQuestion: "अंक प्रति प्रश्न",
    addYourOwnQuestion: "अपना स्वयं का प्रश्न जोड़ें",
    selectChapter: "अध्याय का चयन करें",
    questions: "प्रश्नों का चयन करें",
    class: "कक्षा",
    subject: "विषय",
    time: "समय",
    maxMarks: "अधिकतम अंक",
    noQuestionsFound: "कोई प्रश्न उपलब्ध नहीं है",
    header: "शीर्ष लेख (हैडर)",
    displayHeader: "हेडर प्रदर्शित करें",
    normalHeader: "सामान्य शीर्षलेख",
    letterHead: "लेटर हेड",
    onlyLogo: "केवल लोगो",
    height: "ऊंचाई",
    width: "चौड़ाई",
    goBack: "वापस जाने के लिए",
  },
};

export function getFontSize() {
  const state = reduxStore.getState();
  const mediumList = state.createQstnPaper?.mediumList || [];
  const formData = state.createQstnPaper?.formData || [];
  const selectedMedium = mediumList.find((m) => m.id === formData.medium_id);

  const mediumName = selectedMedium?.name?.toLowerCase() || "";

  const fontValue = getFontSizeByMedium(mediumName);
  console.log("fontValue", fontValue);
  return fontValue;
}
